import api from './api';

const riskAssessmentService = {
  /**
   * List risk assessments, optionally filtered by project/category/status/riskBand.
   */
  async getAll(params = {}) {
    const response = await api.get('/risk-assessments', { params });
    return response.data;
  },

  /**
   * Get a single risk assessment by ID.
   */
  async getById(id) {
    const response = await api.get(`/risk-assessments/${id}`);
    return response.data;
  },

  /**
   * Create a new risk assessment. Server computes riskScore/riskBand from
   * likelihood x severity.
   */
  async create(riskAssessmentData) {
    const response = await api.post('/risk-assessments', riskAssessmentData);
    return response.data;
  },

  /**
   * Update a risk assessment. Server recomputes riskScore/riskBand if
   * likelihood/severity change.
   */
  async update(id, riskAssessmentData) {
    const response = await api.patch(`/risk-assessments/${id}`, riskAssessmentData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/risk-assessments/${id}`);
    return response.data;
  },
};

export default riskAssessmentService;
